import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../components/ui/Loader";
import { useAuth } from "../../hooks/auth/useAuth";
import { authService } from "../../services/authService";
import { User } from "../../types/User";


export default function Redirect() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { setUser } = useAuth()

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!token) {
          navigate("/login");
          return;
        }

        const currentUser: User | null = await authService.getUserProfile(token);

        if (currentUser) {
          setUser(currentUser)
          console.log("currentUser" , currentUser)
          navigate(`/${currentUser.role}/overview`);
        } else {
          navigate("/login");
        }
      } catch (err) {
        navigate("/login");


      }
    };

    fetchUser();
  }, [token, navigate]);

  return <Loader />;
}
